var render = function render(){var _vm=this,_c=_vm._self._c;return _c('admin-wrapper',{ref:"ils-easy-settings-permissions-form",attrs:{"hide-title-row":"","inputs":_vm.inputs,"disable-sticky-buttons":"","has-buttons":false},on:{"setPayloadValue":_vm.setPayload}})
}
var staticRenderFns = []

export { render, staticRenderFns }